// frontend/src/features/campaign/data/initialCampaignData.js

// ── Initial Mock Campaigns List ──
export const INITIAL_CAMPAIGNS = [
  {
    id: 'cmp_101',
    name: 'SEA Enterprise Fintech & SaaS Q4 Outbound',
    objective: 'Accelerate Enterprise Demo Bookings & Net-New ARR Growth',
    product: 'Enterprise AI Lead Gen & Pipeline Engine',
    campaignType: 'Customer Acquisition',
    industrySector: 'Enterprise SaaS',
    targetMarket: 'Malaysia & Singapore',
    targetCompanyType: 'B2B Enterprise / SaaS (50-500 employees)',
    targetPersonas: ['VP Sales', 'Chief Revenue Officer', 'Head of Business Development'],
    channels: ['Email', 'LinkedIn'],
    durationDays: 45,
    currentDay: 14,
    status: 'ACTIVE',
    audienceCount: 650,
    expectedReplies: '40 - 60',
    expectedMeetings: '15 - 25',
    expectedPipeline: 'RM 210,000',
    budget: 'RM 25,000',
    createdAt: '2026-08-28',
    createdBy: 'Sarah Lim (Sales Member)',
    approvedBy: 'Alex Wong (Workspace Owner)',
    submissionNotes: 'Targeting SaaS companies with 50-500 headcount for Q4 sales pipeline.',
    governance: {
      gates: ['brand_voice', 'commercial', 'compliance_deliverability', 'pdpa_privacy'],
      allGatesApproved: true,
      isCertified: true,
      signatureType: 'draw',
      signatureData:
        'data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 240 60" width="240" height="60"><path d="M 20 40 Q 45 10 75 32 T 135 25 T 185 38 T 220 20" fill="none" stroke="%230f172a" stroke-width="2.5" stroke-linecap="round"/></svg>',
      signedBy: 'Alex Wong (Workspace Owner)',
      certId: 'GOV-CERT-2026-904128',
      certHash: 'sha256:4a8b79e1c28f09d841e3d740cba96e62d4e8b3941785f2098d72e61a40307e99',
      securityStandard: 'HMAC-SHA256 (PDPA Compliance)',
      approvedAt: '2026-08-28T14:22:00.000Z',
    },
    strategy: {
      positioning: 'Accelerate B2B pipeline velocity with verified Malaysian decision-maker data.',
      painPoints: 'Low outbound connect rates and manual SDR prospect research.',
      matrix: [
        {
          persona: 'VP Sales / CRO',
          painPoint: 'Rep time wasted manually searching contact information; stale CRM data.',
          valueProp: '100% verified work emails and direct phone dials to double sales pipeline.',
          proofPoint: 'Helped Fintech scaleup book 45 qualified enterprise demos in 30 days.',
          cta: 'Book a 15-minute live platform walkthrough.',
          objection:
            'Already using LinkedIn Sales Nav -> We enrich direct dials and automate multichannel cadence.',
        },
        {
          persona: 'CEO / Founder',
          painPoint: 'High customer acquisition costs and slow revenue growth.',
          valueProp: 'End-to-end outbound automation delivering predictable revenue growth.',
          proofPoint: 'Average 3.8x ROI within the first 60 days of campaign launch.',
          cta: 'Schedule an executive strategy session.',
          objection:
            'Lack of dedicated SDRs -> Our AI operates as an autonomous strategy assistant.',
        },
      ],
      journey: [
        {
          step: 1,
          day: 1,
          channel: 'Email',
          name: 'Introduction & Value Hook',
          condition: 'Initial Touch',
        },
        {
          step: 2,
          day: 4,
          channel: 'LinkedIn',
          name: 'Connection Request & Context',
          condition: 'If No Reply',
        },
        {
          step: 3,
          day: 8,
          channel: 'Email',
          name: 'Follow-up with Case Study',
          condition: 'If No Reply',
        },
        {
          step: 4,
          day: 12,
          channel: 'LinkedIn',
          name: 'Direct Value Pitch / InMail',
          condition: 'If No Reply',
        },
        {
          step: 5,
          day: 18,
          channel: 'Email',
          name: 'Final Break-up & Resource Offer',
          condition: 'If No Reply',
        },
      ],
      kpiForecast: {
        audience: 650,
        reachable: 520,
        replies: '40 - 60',
        positiveReplies: '20 - 30',
        meetings: '15 - 25',
        opportunities: '5 - 8',
        pipelineValue: 'RM 210,000',
      },
    },
  },
  {
    id: 'cmp_102',
    name: 'Malaysia Commercial Banking & Fintech Acquisition',
    objective: 'Book Consultative Executive Demos for Treasury Automation',
    product: 'Corporate Treasury Solution',
    campaignType: 'Account-Based Marketing (ABM)',
    industrySector: 'Fintech & Commercial Banking',
    targetMarket: 'Malaysia (Klang Valley & Regional Hubs)',
    targetCompanyType: 'Commercial Banks & Fintech SMEs',
    targetPersonas: ['CFO', 'Treasury Director', 'Finance VP'],
    channels: ['Email', 'LinkedIn'],
    durationDays: 60,
    currentDay: 0,
    status: 'PENDING_APPROVAL',
    audienceCount: 420,
    expectedReplies: '25 - 40',
    expectedMeetings: '10 - 18',
    expectedPipeline: 'RM 350,000',
    budget: 'RM 30,000',
    createdAt: '2026-09-02',
    createdBy: 'David Tan (Sales Member)',
    approvedBy: null,
    submissionNotes:
      'Specialized outreach targeting CFOs regarding Treasury management & FX risk. Awaiting manager approval.',
    governance: {
      gates: ['brand_voice', 'commercial', 'pdpa_privacy'],
      allGatesApproved: false,
      isCertified: false,
      signatureType: 'draw',
      signedBy: 'David Tan',
      certId: 'GOV-CERT-2026-701086',
      certHash: 'sha256:7f83b1657ff1fc53b92dc18148a1d65dfc2d4b1fa3d677284addd200126d9069',
      securityStandard: 'HMAC-SHA256 (PDPA Compliance)',
      submittedAt: '2026-09-02T10:30:00.000Z',
    },
    strategy: {
      positioning:
        'Eliminate FX exposure and manual multi-bank reconciliation for finance leaders.',
      painPoints: 'Manual spreadsheet reconciliations and volatile currency risks.',
      matrix: [
        {
          persona: 'CFO / Finance Director',
          painPoint: 'Unhedged FX exposure and delays in cash positioning visibility.',
          valueProp:
            'Automated treasury operations with real-time multi-currency cash positioning.',
          proofPoint:
            'Reduced monthly reconciliation time by 85% for top regional logistics group.',
          cta: 'Request an executive Treasury diagnostic consultation.',
          objection: 'Complex ERP integration -> Pre-built connectors with SAP, Oracle, and Xero.',
        },
      ],
      journey: [
        {
          step: 1,
          day: 1,
          channel: 'Email',
          name: 'Executive Peer Briefing',
          condition: 'Initial Touch',
        },
        {
          step: 2,
          day: 5,
          channel: 'LinkedIn',
          name: 'Thought Leadership & Benchmark Report',
          condition: 'If No Reply',
        },
        {
          step: 3,
          day: 10,
          channel: 'Email',
          name: 'CFO Case Study Breakdown',
          condition: 'If No Reply',
        },
        {
          step: 4,
          day: 18,
          channel: 'Email',
          name: 'Direct Consultation Invitation',
          condition: 'If No Reply',
        },
      ],
      kpiForecast: {
        audience: 420,
        reachable: 340,
        replies: '25 - 40',
        positiveReplies: '12 - 20',
        meetings: '10 - 18',
        opportunities: '4 - 6',
        pipelineValue: 'RM 350,000',
      },
    },
  },
  {
    id: 'cmp_103',
    name: 'Q3 Inactive Prospect & Closed-Lost Winback Campaign',
    objective: 'Re-engage Inactive B2B Opportunities with New Product Updates',
    product: 'Next-Gen AI Prospect Finder',
    campaignType: 'Inactive Re-engagement',
    industrySector: 'Enterprise SaaS',
    targetMarket: 'Malaysia & Singapore',
    targetCompanyType: 'Mid-Market B2B Tech',
    targetPersonas: ['VP Sales', 'Head of Business Development', 'Managing Director'],
    channels: ['Email', 'LinkedIn', 'Phone Call'],
    durationDays: 30,
    currentDay: 28,
    status: 'ACTIVE',
    audienceCount: 310,
    expectedReplies: '30 - 50',
    expectedMeetings: '12 - 20',
    expectedPipeline: 'RM 140,000',
    budget: 'RM 12,000',
    createdAt: '2026-08-10',
    createdBy: 'Sarah Lim (Sales Member)',
    approvedBy: 'Alex Wong (Workspace Owner)',
    submissionNotes:
      'Targeting past deals that stalled due to pricing or lack of direct dial verification.',
    governance: {
      gates: ['brand_voice', 'commercial', 'compliance_deliverability', 'pdpa_privacy'],
      allGatesApproved: true,
      isCertified: true,
      signatureType: 'draw',
      signedBy: 'Alex Wong (Workspace Owner)',
      certId: 'GOV-CERT-2026-440291',
      certHash: 'sha256:91b2c4e83a7df09c851e4d70bfa93e51d4e7b2931674f1087d61e50a30296e88',
      securityStandard: 'HMAC-SHA256 (PDPA Compliance)',
      approvedAt: '2026-08-10T09:15:00.000Z',
    },
    strategy: {
      positioning: 'Re-ignite stalled deals with major platform capabilities and improved data.',
      painPoints: 'Previous pricing constraints and feature gaps now resolved in 2026 release.',
      matrix: [
        {
          persona: 'VP Sales',
          painPoint: 'Lost confidence in previous data freshness.',
          valueProp: '99.4% guaranteed phone connectivity with AI multi-channel validation.',
          proofPoint: 'Customer churn decreased by 40% after rolling out verified numbers.',
          cta: 'Check out our 14-day pipeline sprint pilot.',
          objection: 'Already committed to other tools -> Run a zero-risk 100-contact blind test.',
        },
      ],
      journey: [
        {
          step: 1,
          day: 1,
          channel: 'Email',
          name: 'Product Evolution & Apology Hook',
          condition: 'Initial Touch',
        },
        {
          step: 2,
          day: 3,
          channel: 'LinkedIn',
          name: 'Quick Check-in from Leadership',
          condition: 'If No Reply',
        },
        {
          step: 3,
          day: 7,
          channel: 'Email',
          name: 'Special Alumni Pilot Offer',
          condition: 'If No Reply',
        },
      ],
      kpiForecast: {
        audience: 310,
        reachable: 270,
        replies: '30 - 50',
        positiveReplies: '15 - 25',
        meetings: '12 - 20',
        opportunities: '4 - 7',
        pipelineValue: 'RM 140,000',
      },
    },
  },
  {
    id: 'cmp_104',
    name: 'Johor & Northern Corridor Logistics ABM Outbound',
    objective: 'Generate 20+ Enterprise Pipeline Deals with Supply Chain Leaders',
    product: 'Supply Chain AI Workflow Suite',
    campaignType: 'Account-Based Marketing (ABM)',
    industrySector: 'Supply Chain & Logistics',
    targetMarket: 'Malaysia (Penang & Johor)',
    targetCompanyType: 'Logistics, Port Logistics & Cold Chain (100-1000 employees)',
    targetPersonas: ['Chief Operating Officer', 'VP Supply Chain', 'Logistics Director'],
    channels: ['Email', 'LinkedIn'],
    durationDays: 45,
    currentDay: 0,
    status: 'CHANGES_REQUESTED',
    audienceCount: 380,
    expectedReplies: '25 - 45',
    expectedMeetings: '10 - 18',
    expectedPipeline: 'RM 280,000',
    budget: 'RM 20,000',
    createdAt: '2026-09-04',
    createdBy: 'Rachel Lee (Sales Member)',
    approvedBy: null,
    revisionRequestedBy: 'Marcus Yeo (Workspace Owner)',
    revisionRequestedAt: '2026-09-07T14:15:00.000Z',
    revisionFeedback:
      '[Tags: Targeting & ICP Mismatch, PDPA / Regulatory Consent Required]\nPlease refine persona value propositions in Step 3 to address cold-chain compliance, ensure target market accounts match verified Johor hubs, and verify PDPA consent gates before resubmitting.',
    submissionNotes: 'Targeting logistics and warehousing executives in Johor & Penang hubs.',
    governance: {
      gates: ['brand_voice', 'commercial'],
      allGatesApproved: false,
      isCertified: false,
      signatureType: 'draw',
      signedBy: 'Rachel Lee',
      certId: 'GOV-CERT-2026-882041',
      certHash: 'sha256:3e218b76c8109d941e3d740cba96e62d4e8b3941785f2098d72e61a40307e81',
      securityStandard: 'HMAC-SHA256 (PDPA Compliance)',
      submittedAt: '2026-09-04T09:20:00.000Z',
    },
    strategy: {
      positioning: 'Optimize freight velocity and warehouse ops with AI workflow automation.',
      painPoints:
        'Rising fuel surcharges, fragmented EDI documentation, and cold chain visibility.',
      matrix: [
        {
          persona: 'COO / VP Supply Chain',
          painPoint: 'Manual customs document processing and SLA penalties.',
          valueProp:
            'Automate manifest ingest and dispatch tracking with real-time exception alerts.',
          proofPoint: 'Cut customs clearance cycle time by 48% for Port Klang freight forwarders.',
          cta: 'Book a 15-minute logistics workflow diagnostic.',
          objection: 'Existing TMS software -> Seamless webhook integration with CargoWise & SAP.',
        },
      ],
      journey: [
        {
          step: 1,
          day: 1,
          channel: 'Email',
          name: 'Port Logistics Bottleneck Briefing',
          condition: 'Initial Touch',
        },
        {
          step: 2,
          day: 4,
          channel: 'LinkedIn',
          name: 'Executive Connection & Benchmark Insight',
          condition: 'If No Reply',
        },
        {
          step: 3,
          day: 9,
          channel: 'Email',
          name: 'Regional Case Study: 48% Cycle Time Reduction',
          condition: 'If No Reply',
        },
      ],
      kpiForecast: {
        audience: 380,
        reachable: 310,
        replies: '25 - 45',
        positiveReplies: '12 - 22',
        meetings: '10 - 18',
        opportunities: '4 - 7',
        pipelineValue: 'RM 280,000',
      },
    },
  },
];

// ── Realistic Sample Pipeline Leads (CRM Database Fallback) ──
export const SAMPLE_PIPELINE_LEADS = [
  {
    id: 'lead_pip_101',
    name: 'Ahmad Farhan',
    jobTitle: 'Vice President of Sales (VP Sales)',
    company: 'Axiata Digital Solutions',
    industry: 'Enterprise SaaS',
    country: 'Malaysia (Kuala Lumpur)',
    stage: 'Qualified',
    leadScore: 94,
    email: 'farhan.ahmad@axiatadigital.com',
    phone: '+60 12-345 6789',
    linkedinUrl: 'https://linkedin.com/in/ahmadfarhan-sales',
  },
  {
    id: 'lead_pip_102',
    name: 'Rachel Lee',
    jobTitle: 'Chief Revenue Officer (CRO)',
    company: 'Grab Financial Group',
    industry: 'Fintech & Commercial Banking',
    country: 'Malaysia & Singapore',
    stage: 'Engaged',
    leadScore: 91,
    email: 'rachel.lee@grabfinance.com',
    phone: '+65 9123 4567',
    linkedinUrl: 'https://linkedin.com/in/rachel-lee-cro',
  },
  {
    id: 'lead_pip_103',
    name: 'Tan Sri Dr. Wei Lun',
    jobTitle: 'Managing Director / CEO',
    company: 'Berjaya Technology Solutions',
    industry: 'Enterprise SaaS',
    country: 'Malaysia (Selangor)',
    stage: 'New',
    leadScore: 88,
    email: 'weilun.tan@berjayatech.com',
    phone: '+60 13-987 6543',
    linkedinUrl: 'https://linkedin.com/in/weilun-berjaya',
  },
  {
    id: 'lead_pip_104',
    name: 'Sarah Nurul',
    jobTitle: 'Head of Business Development',
    company: 'Maybank Islamic Digital',
    industry: 'Fintech & Commercial Banking',
    country: 'Malaysia (Kuala Lumpur)',
    stage: 'Contacted',
    leadScore: 85,
    email: 'sarah.nurul@maybank.com.my',
    phone: '+60 17-654 3210',
    linkedinUrl: 'https://linkedin.com/in/sarahnurul-bizdev',
  },
  {
    id: 'lead_pip_105',
    name: 'Kevin Wong',
    jobTitle: 'Chief Technology Officer (CTO)',
    company: 'PayNet Payments Network',
    industry: 'Fintech & Commercial Banking',
    country: 'Malaysia (Kuala Lumpur)',
    stage: 'Proposal',
    leadScore: 82,
    email: 'kevin.wong@paynet.my',
    phone: '+60 19-222 3344',
    linkedinUrl: 'https://linkedin.com/in/kevin-wong-cto',
  },
  {
    id: 'lead_pip_106',
    name: 'Melissa Tan',
    jobTitle: 'Treasury Director / VP Finance',
    company: 'Sunway Corporation Group',
    industry: 'Enterprise SaaS',
    country: 'Malaysia (Penang & Selangor)',
    stage: 'Qualified',
    leadScore: 78,
    email: 'melissa.tan@sunway.com.my',
    phone: '+60 16-778 8990',
    linkedinUrl: 'https://linkedin.com/in/melissatan-treasury',
  },
  {
    id: 'lead_pip_107',
    name: 'Mohd Danial',
    jobTitle: 'Chief Information Officer (CIO)',
    company: 'CIMB Bank Regional IT',
    industry: 'Fintech & Commercial Banking',
    country: 'Malaysia (Kuala Lumpur)',
    stage: 'New',
    leadScore: 74,
    email: 'danial.m@cimb.com.my',
    phone: '+60 11-3344 5566',
    linkedinUrl: 'https://linkedin.com/in/mdanial-cio',
  },
  {
    id: 'lead_pip_108',
    name: 'Jessica Chong',
    jobTitle: 'Operations Director / COO',
    company: 'Shopee Express Logistics MY',
    industry: 'Logistics & Supply Chain',
    country: 'Malaysia (Johor & Klang Valley)',
    stage: 'Contacted',
    leadScore: 66,
    email: 'jessica.chong@shopee.com',
    phone: '+60 12-889 9001',
    linkedinUrl: 'https://linkedin.com/in/jessica-chong-ops',
  },
  {
    id: 'lead_pip_109',
    name: 'David Lim',
    jobTitle: 'VP of Enterprise Sales',
    company: 'Pos Malaysia Digital Hub',
    industry: 'Logistics & Supply Chain',
    country: 'Malaysia (Selangor)',
    stage: 'New',
    leadScore: 58,
    email: 'david.lim@pos.com.my',
    phone: '+60 14-556 6778',
    linkedinUrl: 'https://linkedin.com/in/davidlim-pos',
  },
];

// ── Blueprint Playbooks for Quick-Start ──
export const BLUEPRINT_PLAYBOOKS = [
  {
    id: 'playbook_sea_enterprise',
    label: 'SEA Enterprise (Enterprise SaaS)',
    name: 'SEA Enterprise Fintech & SaaS Q4 Outbound',
    primaryObjective: 'Accelerate Enterprise Demo Bookings & Net-New ARR Growth',
    campaignType: 'Customer Acquisition',
    industrySector: 'Enterprise SaaS',
    targetRegion: 'Malaysia & Singapore',
    currency: 'USD',
    allocatedBudget: '$ 25,000',
    startDate: '2026-09-08',
    endDate: '2026-10-23',
    durationDays: 45,
    product: 'Enterprise AI Lead Gen & Pipeline Engine',
    productDescription:
      'B2B platform combining verified decision-maker direct dials with AI-driven cadence.',
    targetPersonas: [
      'Vice President of Sales (VP Sales)',
      'Chief Revenue Officer (CRO)',
      'Head of Business Development',
      'Chief Executive Officer (CEO)',
    ],
    channels: ['Email', 'LinkedIn'],
    avgDealSize: 35000,
  },
  {
    id: 'playbook_tier1_fintech',
    label: 'Tier-1 Target (Fintech & Banking)',
    name: 'Malaysia Commercial Banking & Fintech Acquisition',
    primaryObjective: 'Book Consultative Executive Demos for Treasury Automation',
    campaignType: 'Account-Based Marketing (ABM)',
    industrySector: 'Fintech & Commercial Banking',
    targetRegion: 'Malaysia (All States)',
    currency: 'USD',
    allocatedBudget: '$ 30,000',
    startDate: '2026-09-15',
    endDate: '2026-11-15',
    durationDays: 60,
    product: 'Corporate Treasury & FX Risk Engine',
    productDescription: 'Automated multi-bank cash positioning and FX exposure reconciliation.',
    targetPersonas: [
      'Chief Financial Officer (CFO)',
      'Treasury Director / VP Finance',
      'Chief Information Officer (CIO)',
    ],
    channels: ['Email', 'LinkedIn'],
    avgDealSize: 60000,
  },
  {
    id: 'playbook_dormant_pipeline',
    label: 'Dormant Pipeline (Enterprise SaaS)',
    name: 'Q3 Inactive Prospect & Closed-Lost Winback Campaign',
    primaryObjective: 'Re-engage Inactive B2B Opportunities with New Product Updates',
    campaignType: 'Inactive Re-engagement',
    industrySector: 'Enterprise SaaS',
    targetRegion: 'Malaysia & Singapore',
    currency: 'USD',
    allocatedBudget: '$ 12,000',
    startDate: '2026-09-10',
    endDate: '2026-10-10',
    durationDays: 30,
    product: 'Next-Gen AI Prospect Finder',
    productDescription:
      'Autonomous SDR agent with 100% verified mobile numbers and email addresses.',
    targetPersonas: [
      'Vice President of Sales (VP Sales)',
      'Head of Business Development',
      'Managing Director',
    ],
    channels: ['Email', 'LinkedIn', 'Phone Call'],
    avgDealSize: 25000,
  },
];
